<template>
  <div class="c-ads-filter">
    <div class="c-form">
      <ElForm label-width="0" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model="keyword" placeholder="计划ID / 计划名称" :maxlength="50" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <el-select
            v-model="mediaId"
            :popper-append-to-body="false"
            placeholder="请选择媒体"
            clearable
            collapse-tags
            filterable
            @change="search"
          >
            <el-option v-for="item in mediaData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="newAdv">新建投放位</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim } from '@/common/js/utils'

export default {
  name: 'AdsFilter',
  props: {
    loading: {
      type: Boolean
    },
    queryKey: {
      type: String
    },
    mediaData: {
      type: Array
    }
  },
  data() {
    return {
      keyword: '',
      mediaId: null
    }
  },
  mounted() {
    this.keyword = this.queryKey
  },
  methods: {
    search() {
      const params = {
        keyword: isEmpty(this.keyword) ? undefined : trim(this.keyword),
        mediaId: this.mediaId
      }
      this.$emit('on-search', params)
    },
    newAdv() {
      this.$emit('on-add')
    },
    setQueryKey(queryKey) {
      this.keyword = queryKey
    }
  }
}
</script>
